import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import CalendarBodyLineTasks from './CalendarBodyLineTasks';
import CalendarBodyLineUnit from './CalendarBodyLineUnit';
import Utils from '../../../../../../Services/Utils';
import './style.scss';

/**
 * @callback onAction
 */
/**
 * Calendar workflow line
 * @param {moment} day
 * @param {Array<Moment>} range
 * @param {MRB.Result} unit
 * @param {onAction} onAction
 */
function CalendarBodyLine({ day, range, unit, onAction, isPermissionAvailable }) {
  const [expanded, setExpanded] = useState(true);
  const [actionItems, setActionItems] = useState([]);
  const [lastLevelPosition, setLastLevelPosition] = useState(1);

  const getLevelTaskList = (tasks) => {
    let action_Items = [];
    let level_position = 1
    let setlastLevelPosition = 1
    const currentDate = day.format('YYYY-MM-DD');

    tasks.map((task) => {
      const previous_expected_completion_date = action_Items.length > 0 ? action_Items[action_Items.length - 1].expected_completion_date : null;

      if (action_Items.length === 0) {
        task = { ...task, level_position }
      } else {
        if (moment(currentDate).isBefore(task.start_date) || moment(currentDate).isSame(task.start_date)) {
          if (!moment(task.start_date).isAfter(previous_expected_completion_date)) {
            level_position = level_position + 1
          }
        } else {
          level_position = level_position + 1
        }        

        task = { ...task, level_position}
      }

      setlastLevelPosition = level_position > setlastLevelPosition ? level_position : setlastLevelPosition;
      action_Items = [...action_Items, task];
    });

    setLastLevelPosition(setlastLevelPosition)
    setActionItems(action_Items)
  };

  const getActionItems = useCallback(() => {
    let action_Items = [];
    if (unit.workflow_instances.length > 0) {
      unit.workflow_instances?.map((workflow) => {
        workflow.action_items.map((action) => {
          const addWorkflowStatusAction = {
            ...action,
          }
          action_Items = [...action_Items, addWorkflowStatusAction];
        });
      });
      getLevelTaskList(action_Items);
    } else {
      setLastLevelPosition(1)
      setActionItems([]);
    }
  }, [unit]);

  const getHeight = useCallback(() => {
    const multi = Boolean(expanded) ? 89 : 46
    let height = lastLevelPosition > 1 ? (lastLevelPosition * multi) : multi;
    return (height + 10) + 'px';
  }, [lastLevelPosition, expanded]);

  useEffect(() => {
    getActionItems();
  }, [unit]);

  const moveInDate = useMemo(() => !Utils.isNull(unit.move_in_date) ? moment(unit.move_in_date, 'YYYY/MM/DD').format('MM/DD/YYYY') : null, [unit.move_in_date]);

  return (
    <div className="body_line" style={{ height: getHeight() }}>
        <div className="body_line_column_left">
      <CalendarBodyLineUnit expanded={expanded} onExpand={setExpanded} unit={unit} />
      </div>
      <div className="body_line_column">
        <CalendarBodyLineTasks expanded={expanded} onExpand={setExpanded} tasks={actionItems} onAction={onAction} day={day} range={range}  isPermissionAvailable={isPermissionAvailable} moveInDate={moveInDate}/>
      </div>
    </div>
  );
}

CalendarBodyLine.propTypes = {
  day: PropTypes.any,
  range: PropTypes.array,
  unit: PropTypes.object,
  onAction: PropTypes.func.isRequired,
  isPermissionAvailable: PropTypes.func
};

export default React.memo(CalendarBodyLine);
